import React, { useEffect, useState } from "react";
import {
  Box,
  Dialog,
  TextField,
  Typography,
  Menu,
  MenuItem,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { toast } from "react-toastify";
import apiClient from "Utils/apiClient";

const escortOptions = [{ value: "Virtual Escort", label: "Virtual Escort" }];

const pricingTypes = [
  { value: "Short", label: "Short" },
  { value: "Long", label: "Long" },
];

const paymentModes = [
  { value: "Pay-per-trip", label: "Pay-per-trip" },
  { value: "Subscription", label: "Subscription" },
];

const SubscriptionEscortPricingModal = ({ open, onClose, editData, onSubmit }) => {
  const [formData, setFormData] = useState({
    escort_type: "Virtual Escort",
    pricing_type: "Short",
    payment_mode: "Pay-per-trip",
    user: "",
    base_price: "",
    admin_fee: "",
    currency: "NGN",
  });

  const [menuAnchor, setMenuAnchor] = useState(null);
  const [menuField, setMenuField] = useState("");

  useEffect(() => {
    if (editData) {
      setFormData(editData);
    } else {
      setFormData({
        escort_type: "Virtual Escort",
        pricing_type: "Short",
        payment_mode: "Pay-per-trip",
        user: "",
        base_price: "",
        admin_fee: "",
        currency: "NGN",
      });
    }
  }, [editData, open]);

  const handleChange = (field) => (event) => {
    const value = event.target.value;
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleMenuClick = (field) => (event) => {
    setMenuField(field);
    setMenuAnchor(event.currentTarget);
  };

  const handleMenuClose = (value) => {
    setMenuAnchor(null);
    if (value !== null) {
      setFormData((prev) => ({ ...prev, [menuField]: value }));
    }
    setMenuField("");
  };

  const renderDropdown = (label, field, options) => (
    <FormControl fullWidth>
      <InputLabel shrink>{label}</InputLabel>
      <Box
        onClick={handleMenuClick(field)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          border: "1px solid #c4c4c4",
          borderRadius: "8px",
          padding: "8px",
          cursor: "pointer",
          backgroundColor: "#fff",
        }}
      >
        <Typography>
          {formData[field]
            ? options.find((opt) => opt.value === formData[field])?.label
            : `Select ${label}`}
        </Typography>
        <ArrowDropDownIcon />
      </Box>
      <Menu anchorEl={menuAnchor} open={menuField === field} onClose={() => handleMenuClose(null)}>
        {options.map((option) => (
          <MenuItem key={option.value} onClick={() => handleMenuClose(option.value)}>
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </FormControl>
  );

  const handleSubmit = async () => {
    try {
      const payload = {
        ...formData,
        base_price: Number(formData.base_price) || 0,
        admin_fee: Number(formData.admin_fee) || 0,
      };

      const targetId = editData?.id || editData?._id;

      if (targetId) {
        await apiClient.put(`/escort-pricing/${targetId}`, payload);
        toast.success("Escort Pricing updated successfully.");
      } else {
        await apiClient.post("/escort-pricing", payload);
        toast.success("Escort Pricing saved successfully.");
      }

      // Firebase legacy flow kept for reference while the backend migration is active.
      // const db = getDatabase();
      // if (editData?.id) {
      //   await update(ref(db, `escortpricing/${editData.id}`), formData);
      // } else {
      //   await push(ref(db, "escortpricing"), formData);
      // }

      onSubmit();
    } catch (error) {
      console.error("Error saving escort pricing:", error);
      toast.error(error?.response?.data?.message || "Failed to save Escort Pricing.");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <IconButton
        edge="end"
        onClick={onClose}
        aria-label="close"
        sx={{ position: "absolute", top: 10, right: 10 }}
      >
        <CloseIcon />
      </IconButton>

      <Box
        component="form"
        sx={{
          padding: 4,
          display: "flex",
          flexDirection: "column",
          gap: 3,
          backgroundColor: "#f7f9fc",
        }}
      >
        <Typography variant="h5" fontWeight="bold">
          {editData ? "Edit Escort Pricing" : "Add Escort Pricing"}
        </Typography>

        {renderDropdown("Escort Type", "escort_type", escortOptions)}
        {renderDropdown("Pricing Type", "pricing_type", pricingTypes)}
        {renderDropdown("Payment Modal", "payment_mode", paymentModes)}

        <TextField
          fullWidth
          label="User"
          variant="outlined"
          value={formData.user}
          onChange={handleChange("user")}
        />

        <FormControl fullWidth>
          <InputLabel htmlFor="base_price">Base Price</InputLabel>
          <OutlinedInput
            id="base_price"
            type="number"
            value={formData.base_price}
            onChange={handleChange("base_price")}
            startAdornment={<InputAdornment position="start">₦</InputAdornment>}
            label="Base Price"
          />
        </FormControl>

        <FormControl fullWidth>
          <InputLabel htmlFor="admin_fee">Admin Fee</InputLabel>
          <OutlinedInput
            id="admin_fee"
            type="number"
            value={formData.admin_fee}
            onChange={handleChange("admin_fee")}
            startAdornment={<InputAdornment position="start">₦</InputAdornment>}
            label="Admin Fee"
          />
        </FormControl>

        <TextField
          fullWidth
          label="Currency"
          variant="outlined"
          value={formData.currency}
          onChange={handleChange("currency")}
        />

        <Button
          onClick={handleSubmit}
          variant="contained"
          sx={{
            width: "40%",
            backgroundColor: "#1976d2",
            color: "#ffffff",
            fontWeight: "bold",
            padding: "12px 0",
            fontSize: "16px",
            textTransform: "none",
            borderRadius: "8px",
            "&:hover": {
              backgroundColor: "#1565c0",
            },
          }}
        >
          {editData ? "Update" : "Save"}
        </Button>
      </Box>
    </Dialog>
  );
};

export default SubscriptionEscortPricingModal;
